import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

interface OrientationSectionProps {
  orientation: "horizontal" | "vertical";
  onOrientationChange: (value: "horizontal" | "vertical") => void;
}

const OrientationSection: React.FC<OrientationSectionProps> = ({
  orientation,
  onOrientationChange,
}) => {
  return (
    <Box>
      <FormControl component="fieldset">
        <FormLabel component="legend">Orientation</FormLabel>
        <RadioGroup
          value={orientation}
          onChange={(e) =>
            onOrientationChange(e.target.value as "horizontal" | "vertical")
          }
        >
          <FormControlLabel
            value="horizontal"
            control={<Radio size="small" />}
            label="Horizontal"
          />
          <FormControlLabel
            value="vertical"
            control={<Radio size="small" />}
            label="Vertical"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default OrientationSection;
